import * as React from "react";
function SvgTagPadlock(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M43.1 17.8l-4.8 6 1.9 1.5 6.5-7.9L25.1 0 1.3 29.5l3.4 17.1 17.5.4v-2.5l-15.4-.3L4 30.3 25.5 3.6l17.6 14.2zM8.8 35c0 2.8 2.3 5.1 5.1 5.1S19 37.8 19 35s-2.3-5.1-5.1-5.1-5.1 2.3-5.1 5.1zm7.6 0c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5zm16.3 2.8h2.5v3.8h-2.5v-3.8zm1.6-11.6c-3.1.1-5.5 2.3-6.2 5.2h-1.8V48h16.6V31.4h-2.3c-.8-2.9-3.4-5-6.3-5.2zm0 2.6c1.7.1 3.1 1.1 3.6 2.7h-7.1c.5-1.6 1.9-2.6 3.5-2.7zm6 16.7H28.8V34h11.5v11.5z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTagPadlock);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
